import { c as _c } from "react/compiler-runtime";
import type Fuse from 'fuse.js';
import { useState } from 'react';
import * as React from 'react';
import { useDebounce } from 'react-use';
import { fuzzySearch } from './fuzzy-search';
interface UseFuzzyReturnValue<T> {
  query: string;
  debouncedQuery: string;
  results: T[];
  search: (query: string) => void;
}
export type FuzzySearchOptions<T> = Partial<Fuse.IFuseOptions<T>> & {
  debounce?: number;
};
export function useFuzzy(data, options) {
  const $ = _c(15);
  let fuzzyOptions;
  let t0;
  if ($[0] !== options) {
    ({
      debounce: t0,
      ...fuzzyOptions
    } = options);
    $[0] = options;
    $[1] = fuzzyOptions;
    $[2] = t0;
  } else {
    fuzzyOptions = $[1];
    t0 = $[2];
  }
  const debounce = t0 === undefined ? 0 : t0;
  const [query, setQuery] = React.useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  let t1;
  if ($[3] !== query) {
    t1 = () => {
      setDebouncedQuery(query);
    };
    $[3] = query;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== query) {
    t2 = [query, setDebouncedQuery];
    $[5] = query;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useDebounce(t1, debounce, t2);
  let t3;
  if ($[7] !== data || $[8] !== debouncedQuery || $[9] !== fuzzyOptions) {
    t3 = fuzzySearch(data, debouncedQuery, fuzzyOptions);
    $[7] = data;
    $[8] = debouncedQuery;
    $[9] = fuzzyOptions;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const results = t3;
  let t4;
  if ($[11] !== debouncedQuery || $[12] !== query || $[13] !== results) {
    t4 = {
      query,
      debouncedQuery,
      results,
      search: setQuery
    };
    $[11] = debouncedQuery;
    $[12] = query;
    $[13] = results;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}